document.addEventListener('DOMContentLoaded', () => {
  localStorage.removeItem('searchUsersPage')
  localStorage.removeItem('searchUsersResult')
  const groupsUsersCacheKeys = Object.keys(localStorage).filter(name => /groups\d+Users(Result || Page)/.test(name))
  groupsUsersCacheKeys.map(key => {
    localStorage.removeItem(key)
  })
})
